"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));

var _excluded = ["onClick", "size", "icon", "type"];

var PopUpMenuButton = function PopUpMenuButton(_ref) {
  var onClick = _ref.onClick,
      size = _ref.size,
      icon = _ref.icon,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "button" : _ref$type,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], (0, _extends2["default"])({
    position: "absolute",
    top: "20px",
    right: "8px",
    width: "auto"
  }, props), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    size: size,
    icon: icon,
    onClick: onClick,
    type: type
  }));
};

var _default = PopUpMenuButton;
exports["default"] = _default;